import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Component({
    name: 'gnbsub-item'
})
export default class GnbItemSubItem extends Vue {
    @Prop({type:Object}) item!: appbase.cache.TMenuItem;
    @Prop({type:String}) userLang!: string;

    get customClass(){
        if (this.item.customClass){
            return this.item.customClass;
        }
        return ""; 
    } 
}